module.exports = __webpack_public_path__ + "gifts.svg?261036f739ee2f89c2b67bcace86dcd5";